import React, { useEffect, useMemo, useState } from 'react';

const NotificationsPage = ({
  notificationForm,
  setNotificationForm,
  addNotification,
  notificationMessage,
  notifications,
}) => {
  const [filters, setFilters] = useState({
    type: 'all',
    user: '',
    from: '',
    to: '',
  });
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  useEffect(() => {
    setPage(1);
  }, [filters, pageSize]);

  const filtered = useMemo(() => {
    const user = filters.user.trim().toLowerCase();
    return (notifications || []).filter((n) => {
      if (filters.type !== 'all' && String(n.type || '').toUpperCase() !== filters.type) return false;
      if (user && !String(n.user_id || '').toLowerCase().includes(user)) return false;
      if (filters.from) {
        const d = new Date(n.created_at);
        if (Number.isFinite(d.getTime())) {
          const start = new Date(filters.from);
          if (d < start) return false;
        }
      }
      if (filters.to) {
        const d = new Date(n.created_at);
        if (Number.isFinite(d.getTime())) {
          const end = new Date(filters.to);
          end.setHours(23, 59, 59, 999);
          if (d > end) return false;
        }
      }
      return true;
    });
  }, [notifications, filters]);

  const totalPages = Math.max(1, Math.ceil(filtered.length / pageSize));
  const currentPage = Math.min(page, totalPages);
  const paged = filtered.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  return (
    <div className="card">
      <h3>Notifications</h3>
      <div className="grid">
        <div><label>Title</label><input value={notificationForm.title} onChange={(e) => setNotificationForm({ ...notificationForm, title: e.target.value })} /></div>
        <div><label>Type</label><input value={notificationForm.type} onChange={(e) => setNotificationForm({ ...notificationForm, type: e.target.value })} /></div>
      </div>
      <div><label>Message</label><textarea value={notificationForm.message} onChange={(e) => setNotificationForm({ ...notificationForm, message: e.target.value })} /></div>
      <div><label>Target User ID</label><input value={notificationForm.user_id} onChange={(e) => setNotificationForm({ ...notificationForm, user_id: e.target.value })} /></div>
      <button onClick={addNotification}>Send Notification</button>
      {notificationMessage ? <div className="muted">{notificationMessage}</div> : null}
      <div className="filters">
        <div className="filter-row">
          <div>
            <label>Type</label>
            <select value={filters.type} onChange={(e) => setFilters({ ...filters, type: e.target.value })}>
              <option value="all">All</option>
              <option value="INFO">INFO</option>
              <option value="SUCCESS">SUCCESS</option>
              <option value="WARNING">WARNING</option>
              <option value="ALERT">ALERT</option>
            </select>
          </div>
          <div>
            <label>User ID</label>
            <input value={filters.user} onChange={(e) => setFilters({ ...filters, user: e.target.value })} placeholder="Search user id" />
          </div>
          <div>
            <label>From</label>
            <input type="date" value={filters.from} onChange={(e) => setFilters({ ...filters, from: e.target.value })} />
          </div>
          <div>
            <label>To</label>
            <input type="date" value={filters.to} onChange={(e) => setFilters({ ...filters, to: e.target.value })} />
          </div>
          <div>
            <label>Page Size</label>
            <select value={pageSize} onChange={(e) => setPageSize(Number(e.target.value))}>
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={50}>50</option>
            </select>
          </div>
        </div>
        <div className="filter-actions">
          <div className="muted">Showing {paged.length} of {filtered.length}</div>
          <div className="pager">
            <button className="secondary" disabled={currentPage <= 1} onClick={() => setPage((p) => Math.max(1, p - 1))}>Prev</button>
            <span className="pager-info">Page {currentPage} of {totalPages}</span>
            <button className="secondary" disabled={currentPage >= totalPages} onClick={() => setPage((p) => Math.min(totalPages, p + 1))}>Next</button>
          </div>
        </div>
      </div>
      <div className="list">
        {paged.map((n, i) => (
          <div key={`${n.id}-${i}`} className="list-item">
            <strong>{n.title}</strong>
            <div className="muted">{n.type || 'INFO'}{n.user_id ? ` · ${n.user_id}` : ''}</div>
            <div className="muted">{n.message}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NotificationsPage;
